
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getCurrentUser",
      resolverType: "query",
      routePath: "/getCurrentUser",
      httpMethod: "POST",
    });
  